// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","back":"Header_back__C7M14","totalContainer":"Header_totalContainer__EYARH","button":"Header_button__eZN2O"};